import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { string, object } from "yup";
import BulkInsertForm from "../Components/CartBulkinsert";
import { bulkinsert, setError } from "../Actions/CartBulkinsert.action";
import { translate } from "../Services/translation";
import constants from "../constants";
import { add as addcart } from "../Actions/Cart.action";

class CartBulkInsertContainer extends Component {
  constructor(props) {
    super(props);
    this.bulkinsertref = React.createRef();
    this.state = {
      productlist: "",
      error: "",
      result: {},
      isclear: false,
    };
  }

  handleBulkinsertInputChange(propName, value) {
    this.setState((prevState) => ({
      ...prevState,
      productlist: value,
      isclear: true,
    }));
  }

  handleBulkinsertCancel() {
    this.setState({
      productlist: "",
      error: "",
      result: {},
      isclear: true,
    });
  }

  onBulkinsertSubmit(productlist) {
    this.setState({ isclear: false });
    let namesSplit = productlist.split(/\r?\n/);
    let errorrows = "";
    var itemval = "";
    var validdata = true;
    var productarray = [];
    for (var i = 0; i < namesSplit.length; i++) {
      var article = "";
      var quantity = "";
      itemval = namesSplit[i];
      if (itemval != null && itemval != "") {
        itemval=itemval.replace(/\t/g, ' ');
        itemval=itemval.replace(",0",".0");

        if (itemval.includes(",")) {
          article = itemval.split(",")[0];
          quantity = itemval.split(",")[1];
          if(isNaN(quantity) || quantity.includes("-") ){
            validdata=false;
            errorrows=itemval;
            break;
          }
        } else if (itemval.includes(" ")) {
          let ar1 = itemval.split(" ");
          article = ar1[0];
          quantity = ar1[ar1.length - 1];
          if(isNaN(quantity) || quantity.includes("-") ){
            validdata=false;
            errorrows=itemval;
            break;
          }
        }
         else {
          article = itemval;
          quantity = "1";
        }
      }
      if (article != "undefined" && article != "") {
        productarray.push({ ArticleNumber: article, Quantity: quantity });
      } else {
        if(itemval!=""){
        validdata = false;
        errorrows=itemval;
        break;
        }
      }
    }
    if (validdata) {
      this.setState({ error: {} });
     var res= this.props.bulkinsert(this.bulkinsertref.current,productarray);
    
    
   } else {
      let err = {};
      //err["general"] = "Invalid data";
      err["general"] = errorrows;
      this.setState({ error: err });
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.result.isSuccess) {
      this.setState({
        productlist: "",
        error: "",
        result: {},
       isclear:true,
      });
    }
  }

  render() {
    return (
      <Fragment>
        {
          <span ref={this.bulkinsertref}>
            <BulkInsertForm
              productlist={this.state.productlist}
              btnref={this.buttonRef}
              errors={this.state.error}
              result={this.props.result}
              isclear={this.state.isclear}
              onDismiss={() => this.handleBulkinsertCancel()}
              onChange={(propName, value) =>
                this.handleBulkinsertInputChange(propName, value)
              }
              onSubmit={(productlist) => this.onBulkinsertSubmit(productlist)}
            />
          </span>
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
 
  return {
    errors: state.cartbulkinsert.errors,
    result: state.cartbulkinsert.result,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    bulkinsert: (buttonDomNode, productlistarr) => {
      const nodeIdToShowNotification = (buttonDomNode.id = Date.now());
      dispatch(
        bulkinsert({
          productlistarr,
          nodeIdToShowNotification,
          notificationMessage: translate("tooltip.addedtocart"),
          hash: Date.now(),
        })
      ).then(() =>
        dispatch(
          addcart({
            articleNumber: 0,
            quantity: 1,
            nodeIdToShowNotification,
            notificationMessage: translate("tooltip.addedtocart"),
            hash: Date.now(),
          }))
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CartBulkInsertContainer);
